import React from 'react';

import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { Divider } from '@mui/material';

<Stack spacing={1}>
  <Skeleton variant="text" />
  <Skeleton variant="circular" width={40} height={40} />
  <Skeleton variant="rectangular" width={210} height={118} />
</Stack>

export default function JObPurchaseSkeleton() {


  return (
    <div>
      
      <p style={{ color: "var(--orange)", fontWeight: '600' }} >Purchase Details</p>
      <div>

        <div className="bottom-inputs" style={{ marginBottom: "2em" }}>
          <div className="input-column" style={{ margin: "0 2em 1em 0" }} >
            <label style={{ marginRight: '0.5em' }}>Email Account Used</label>
            <Skeleton variant="rectangular" width={250} height={32} />
          </div>

          <div className="input-column" style={{ margin: "0 2em 1em 0" }} >
            <label style={{ marginRight: '1em' }}>New Site Password</label>
            <Skeleton variant="rectangular" width={200} height={32} />
          </div>

          <div className="input-column" style={{ margin: "0 2em 1em 0" }}>
            <label style={{ marginRight: '0.5em' }}>Credit Card Used</label>
            <Skeleton variant="rectangular" width={250} height={32} />
          </div>
        </div>

        <div className="input-list" style={{ justifyContent: "flex-start" }}>

          <div className="input-column">
            <label>Quantity </label>
            <Skeleton variant="rectangular" width={200} height={32} />
          </div>

          <div className="input-column">
            <label>Section </label>
            <Skeleton variant="rectangular" width={200} height={32} />
          </div>

          <div className="input-column">
            <label>Row </label>
            <Skeleton variant="rectangular" width={200} height={32} />
          </div>

          <div className="input-column">
            <label>Seats </label>
            <Skeleton variant="rectangular" width={200} height={32} />
          </div>

          <div className="input-column">
            <label>Delivery Method</label>
            <Skeleton variant="rectangular" width={200} height={32} />
          </div>

          <div className="input-column">
            <label>Total Spend </label>
            <Skeleton variant="rectangular" width={200} height={32} />
          </div>

          <div className="input-column">
            <label>Order Number</label>
            <Skeleton variant="rectangular" width={200} height={32} />
          </div>

          <div className="input-column">
            <label>Code Used</label>
            <Skeleton variant="rectangular" width={200} height={32} />
          </div>

        </div>

      </div>
     
    </div>

  )
}


